var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { staticClass: "app-container" },
    [
      _c(
        "div",
        { staticClass: "filter-container" },
        [
          _c("el-date-picker", {
            staticClass: "filter-item",
            staticStyle: { width: "150px" },
            attrs: {
              type: "date",
              placeholder: "Start Date",
              "value-format": "yyyy-MM-dd",
            },
            model: {
              value: _vm.startDate,
              callback: function ($$v) {
                _vm.startDate = $$v
              },
              expression: "startDate",
            },
          }),
          _c("el-date-picker", {
            staticClass: "filter-item",
            staticStyle: { width: "150px" },
            attrs: {
              type: "date",
              placeholder: "End Date",
              "value-format": "yyyy-MM-dd",
            },
            model: {
              value: _vm.endDate,
              callback: function ($$v) {
                _vm.endDate = $$v
              },
              expression: "endDate",
            },
          }),
          _c(
            "el-button",
            {
              staticClass: "filter-item",
              attrs: { type: "primary", icon: "el-icon-search" },
              on: { click: _vm.loadDashboard },
            },
            [_vm._v(" Load Dashboard ")]
          ),
          _c(
            "el-button",
            {
              staticClass: "filter-item",
              attrs: { icon: "el-icon-refresh" },
              on: { click: _vm.loadDashboard },
            },
            [_vm._v(" Refresh ")]
          ),
        ],
        1
      ),
      _c(
        "el-row",
        { staticStyle: { "margin-bottom": "20px" }, attrs: { gutter: 20 } },
        [
          _c(
            "el-col",
            { attrs: { span: 6 } },
            [
              _c(
                "el-card",
                { staticClass: "stat-card", attrs: { shadow: "hover" } },
                [
                  _c("div", { staticClass: "stat-content" }, [
                    _c("i", {
                      staticClass: "el-icon-mobile-phone stat-icon",
                      staticStyle: { color: "#67C23A" },
                    }),
                    _c("div", { staticClass: "stat-info" }, [
                      _c("div", { staticClass: "stat-value" }, [
                        _vm._v(_vm._s(_vm.stats.android)),
                      ]),
                      _c("div", { staticClass: "stat-label" }, [
                        _vm._v("Android Webhooks"),
                      ]),
                    ]),
                  ]),
                ]
              ),
            ],
            1
          ),
          _c(
            "el-col",
            { attrs: { span: 6 } },
            [
              _c(
                "el-card",
                { staticClass: "stat-card", attrs: { shadow: "hover" } },
                [
                  _c("div", { staticClass: "stat-content" }, [
                    _c("i", {
                      staticClass: "el-icon-mobile stat-icon",
                      staticStyle: { color: "#409EFF" },
                    }),
                    _c("div", { staticClass: "stat-info" }, [
                      _c("div", { staticClass: "stat-value" }, [
                        _vm._v(_vm._s(_vm.stats.ios)),
                      ]),
                      _c("div", { staticClass: "stat-label" }, [
                        _vm._v("iOS Webhooks"),
                      ]),
                    ]),
                  ]),
                ]
              ),
            ],
            1
          ),
          _c(
            "el-col",
            { attrs: { span: 6 } },
            [
              _c(
                "el-card",
                { staticClass: "stat-card", attrs: { shadow: "hover" } },
                [
                  _c("div", { staticClass: "stat-content" }, [
                    _c("i", {
                      staticClass: "el-icon-success stat-icon",
                      staticStyle: { color: "#67C23A" },
                    }),
                    _c("div", { staticClass: "stat-info" }, [
                      _c("div", { staticClass: "stat-value" }, [
                        _vm._v(_vm._s(_vm.stats.activeEvents)),
                      ]),
                      _c("div", { staticClass: "stat-label" }, [
                        _vm._v("Active Subscriptions"),
                      ]),
                    ]),
                  ]),
                ]
              ),
            ],
            1
          ),
          _c(
            "el-col",
            { attrs: { span: 6 } },
            [
              _c(
                "el-card",
                { staticClass: "stat-card", attrs: { shadow: "hover" } },
                [
                  _c("div", { staticClass: "stat-content" }, [
                    _c("i", {
                      staticClass: "el-icon-warning stat-icon",
                      staticStyle: { color: "#E6A23C" },
                    }),
                    _c("div", { staticClass: "stat-info" }, [
                      _c("div", { staticClass: "stat-value" }, [
                        _vm._v(_vm._s(_vm.stats.problems)),
                      ]),
                      _c("div", { staticClass: "stat-label" }, [
                        _vm._v("Recent Problems"),
                      ]),
                    ]),
                  ]),
                ]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-row",
        { staticStyle: { "margin-bottom": "20px" }, attrs: { gutter: 20 } },
        [
          _c(
            "el-col",
            { attrs: { span: 12 } },
            [
              _c("el-card", { attrs: { shadow: "hover" } }, [
                _c("div", { attrs: { slot: "header" }, slot: "header" }, [
                  _c("strong", [_vm._v("Events by Type")]),
                ]),
                _c(
                  "div",
                  { staticClass: "chart-container" },
                  [
                    _c(
                      "el-table",
                      {
                        attrs: {
                          data: _vm.eventsByType,
                          size: "small",
                          border: "",
                        },
                      },
                      [
                        _c("el-table-column", {
                          attrs: {
                            prop: "event_type",
                            label: "Event Type",
                            width: "180",
                          },
                          scopedSlots: _vm._u([
                            {
                              key: "default",
                              fn: function ({ row }) {
                                return [
                                  _c(
                                    "el-tag",
                                    {
                                      attrs: {
                                        type: _vm.getEventTypeTag(
                                          row.event_type
                                        ),
                                        size: "small",
                                      },
                                    },
                                    [
                                      _vm._v(
                                        " " +
                                          _vm._s(
                                            _vm.getEventTypeLabel(
                                              row.event_type
                                            )
                                          ) +
                                          " "
                                      ),
                                    ]
                                  ),
                                ]
                              },
                            },
                          ]),
                        }),
                        _c("el-table-column", {
                          attrs: {
                            prop: "total",
                            label: "Count",
                            align: "center",
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ]),
            ],
            1
          ),
          _c(
            "el-col",
            { attrs: { span: 12 } },
            [
              _c("el-card", { attrs: { shadow: "hover" } }, [
                _c("div", { attrs: { slot: "header" }, slot: "header" }, [
                  _c("strong", [_vm._v("Events by Status")]),
                ]),
                _c(
                  "div",
                  { staticClass: "chart-container" },
                  [
                    _c(
                      "el-table",
                      {
                        attrs: {
                          data: _vm.eventsByStatus,
                          size: "small",
                          border: "",
                        },
                      },
                      [
                        _c("el-table-column", {
                          attrs: {
                            prop: "status",
                            label: "Status",
                            width: "180",
                          },
                          scopedSlots: _vm._u([
                            {
                              key: "default",
                              fn: function ({ row }) {
                                return [
                                  _c(
                                    "el-tag",
                                    {
                                      attrs: {
                                        type: _vm.getStatusTag(row.status),
                                        size: "small",
                                      },
                                    },
                                    [
                                      _vm._v(
                                        " " +
                                          _vm._s(
                                            _vm.getStatusLabel(row.status)
                                          ) +
                                          " "
                                      ),
                                    ]
                                  ),
                                ]
                              },
                            },
                          ]),
                        }),
                        _c("el-table-column", {
                          attrs: {
                            prop: "total",
                            label: "Count",
                            align: "center",
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ]),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-card",
        {
          staticStyle: { "margin-bottom": "20px" },
          attrs: { shadow: "hover" },
        },
        [
          _c(
            "div",
            { attrs: { slot: "header" }, slot: "header" },
            [
              _c("strong", [_vm._v("Recent Problems (Last 7 Days)")]),
              _c(
                "el-tag",
                {
                  staticStyle: { "margin-left": "10px" },
                  attrs: { type: "danger", size: "small" },
                },
                [_vm._v(" " + _vm._s(_vm.recentProblems.length) + " issues ")]
              ),
            ],
            1
          ),
          _c(
            "el-table",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.loading,
                  expression: "loading",
                },
              ],
              staticStyle: { width: "100%" },
              attrs: { data: _vm.recentProblems, border: "", size: "small" },
            },
            [
              _c("el-table-column", {
                attrs: { prop: "eventType", label: "Event Type", width: "150" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function ({ row }) {
                      return [
                        _c(
                          "el-tag",
                          {
                            attrs: {
                              type: _vm.getEventTypeTag(
                                row.eventType || row.event_type
                              ),
                              size: "small",
                            },
                          },
                          [
                            _vm._v(
                              " " +
                                _vm._s(
                                  _vm.getEventTypeLabel(
                                    row.eventType || row.event_type
                                  )
                                ) +
                                " "
                            ),
                          ]
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "platform",
                  label: "Platform",
                  width: "100",
                  align: "center",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function ({ row }) {
                      return [
                        _c(
                          "el-tag",
                          {
                            attrs: {
                              type:
                                row.platform === "ios" ? "primary" : "success",
                              size: "small",
                            },
                          },
                          [_vm._v(" " + _vm._s(row.platform) + " ")]
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: { prop: "userEmail", label: "User Email", width: "200" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function ({ row }) {
                      return [
                        _vm._v(
                          " " +
                            _vm._s(row.userEmail || row.user_email || "N/A") +
                            " "
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: { prop: "productId", label: "Product", width: "200" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function ({ row }) {
                      return [
                        _vm._v(
                          " " + _vm._s(row.productId || row.product_id) + " "
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: { prop: "cancellationReason", label: "Reason" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function ({ row }) {
                      return [
                        _vm._v(
                          " " +
                            _vm._s(
                              _vm.getCancellationReasonLabel(
                                row.cancellationReason ||
                                  row.cancellation_reason
                              )
                            ) +
                            " "
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: { prop: "eventDate", label: "Date", width: "160" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function ({ row }) {
                      return [
                        _vm._v(
                          " " +
                            _vm._s(
                              _vm.formatDate(row.eventDate || row.event_date)
                            ) +
                            " "
                        ),
                      ]
                    },
                  },
                ]),
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-card",
        { attrs: { shadow: "hover" } },
        [
          _c("div", { attrs: { slot: "header" }, slot: "header" }, [
            _c("strong", [_vm._v("Daily Webhook Trends (Last 7 Days)")]),
          ]),
          _c(
            "el-table",
            {
              staticStyle: { width: "100%" },
              attrs: { data: _vm.dailyTrends, border: "", size: "small" },
            },
            [
              _c("el-table-column", {
                attrs: { prop: "date", label: "Date", width: "150" },
              }),
              _c("el-table-column", {
                attrs: { prop: "platform", label: "Platform", width: "100" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function ({ row }) {
                      return [
                        _c(
                          "el-tag",
                          {
                            attrs: {
                              type:
                                row.platform === "ios" ? "primary" : "success",
                              size: "small",
                            },
                          },
                          [_vm._v(" " + _vm._s(row.platform) + " ")]
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: { prop: "count", label: "Count", align: "center" },
              }),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }